export default "__VITE_ASSET__BtVQmMQP__"